/**
 * @generated SignedSource<<15530ff2f87f9c378f01123931eb1bdb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TradeRule",
    "kind": "LinkedField",
    "name": "proposeNominatedTrade",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uuid",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProposeNominatedTradeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProposeNominatedTradeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "743c3d26ff8c08fb3ad3e941e0ac72dd",
    "id": null,
    "metadata": {},
    "name": "ProposeNominatedTradeMutation",
    "operationKind": "mutation",
    "text": "mutation ProposeNominatedTradeMutation(\n  $input: NominatedTradeRuleProposal!\n) {\n  proposeNominatedTrade(input: $input) {\n    id\n    uuid\n  }\n}\n"
  }
};
})();

node.hash = "9fcf2c651bde0b97670c73cc2e16976a";

module.exports = node;
